import React, { memo } from "react";

const ShootingStars = () => null;

export default memo(ShootingStars);
